// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"b70257af","232":"aef50922","237":"0e7930cd","526":"aaa0c49e","787":"2760cc96"}[chunkId] + ".chunk.js";
};